import { IconProps } from "../../utils/global-types/global-types";

const AgentsNewIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-5 h-5"}
    {...rest}
  >
    <g clipPath="url(#clip0_34725_293200)">
      <path
        fill="currentColor"
        d="M15.46 9.696 8.578 2.814c-.256-.255-.76-.464-1.122-.464H3.009a.66.66 0 0 0-.657.657v4.447c0 .361.209.866.464 1.122l6.882 6.882a.66.66 0 0 0 .93 0l4.832-4.832a.66.66 0 0 0 0-.93M5.14 6.096a1.154 1.154 0 1 1 0-2.308 1.154 1.154 0 0 1 0 2.308"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_34725_293200">
        <path fill="currentColor" d="M2 2h14v14H2z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default AgentsNewIcon;
